import * as React from 'react';
import type { SVGProps } from 'react';

const IconDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    {...props}
  >
    <path
      d="M5.9314 0.5L5.9314 -2.18557e-08L4.9314 2.18557e-08L4.9314 0.5L5.4314 0.5L5.9314 0.5ZM5.07784 7.41587C5.27311 7.61113 5.58969 7.61113 5.78495 7.41587L8.96693 4.23389C9.16219 4.03863 9.16219 3.72205 8.96693 3.52678C8.77167 3.33152 8.45509 3.33152 8.25982 3.52678L5.4314 6.35521L2.60297 3.52678C2.40771 3.33152 2.09112 3.33152 1.89586 3.52678C1.7006 3.72205 1.7006 4.03863 1.89586 4.23389L5.07784 7.41587ZM5.4314 0.5L4.9314 0.5L4.9314 7.06232L5.4314 7.06232L5.9314 7.06232L5.9314 0.5L5.4314 0.5Z"
      fill="currentColor"
    />
    <line y1="10.2212" x2="10.8628" y2="10.2212" stroke="currentColor" />
  </svg>
);
export default IconDownload;
